import { render, staticRenderFns } from "./EmployeeMedicalInformation.vue?vue&type=template&id=cff9ed72"
import script from "./EmployeeMedicalInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeMedicalInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeMedicalInformation.vue?vue&type=style&index=0&id=cff9ed72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports